// Vendors
import React, { useState, useEffect } from 'react';
import axios from 'axios';

// Components
import { Loader, DispatchUnreadMsgAmount } from '../../../components';

const Messages = ({ projectData, setUnreadMessages }) => {
  const [loading, setLoading] = useState(true);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const { pid } = projectData;
  const [unreadSince, setUnreadSince] = useState(0);
  let _isSubscribed = true;

  const postMessage = () => {
    if (!newMessage || !pid) return;

    _isSubscribed = true;

    const formData = new FormData();
    formData.append('action', 'wl_pip_post_project_message');
    formData.append('message', newMessage);
    formData.append('pid', pid);

    axios({
      method: 'post',
      url: window.wlPipConfig.ajaxUrl,
      data: formData
    })
      .then(
        ({
          data: {
            success,
            data: { comments }
          }
        }) => {
          if (_isSubscribed) {
            if (success) {
              setMessages(comments);
              setNewMessage('');
            }

            setLoading(false);
          }
        }
      )
      .catch(({ data: { success, data } }) => {
        setLoading(false);
      });
  };

  const handleMarkAsRead = () => {
    if (!pid) return;

    const formData = new FormData();
    formData.append('action', 'wl_mark_project_as_read');
    formData.append('pid', pid);
    formData.append('type', 'projects');

    axios({
      method: 'post',
      url: window.wlPipConfig.ajaxUrl,
      data: formData
    })
      .then(
        ({
          data: {
            success,
            data: { comments, unread_since }
          }
        }) => {
          if (success) {
            setMessages(comments);
            setUnreadSince(unread_since);
            setUnreadMessages(unread_since);
          }

          DispatchUnreadMsgAmount();
          setLoading(false);
        }
      )
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    _isSubscribed = true;
    setLoading(true);

    const formData = new FormData();
    formData.append('action', 'wl_pip_get_project_messages');
    formData.append('pid', pid);

    axios({
      method: 'post',
      url: window.wlPipConfig.ajaxUrl,
      data: formData
    })
      .then(
        ({
          data: {
            success,
            data: { comments, unread_since }
          }
        }) => {
          if (_isSubscribed) {
            setUnreadSince(unread_since);
            if (success) setMessages(comments);
            setLoading(false);
          }
        }
      )
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });

    return () => (_isSubscribed = false);
  }, []);

  if (loading) return <Loader />;

  return (
    <div id="pip-project-messages">
      <div className="grid">
        <div className="grid__col-xs-12">
          <div
            className="form__field u--margin-bottom-20"
            style={{ maxWidth: '600px' }}
          >
            <textarea
              type="textarea"
              className="form__textarea form__textarea--no-shadow"
              value={newMessage}
              onChange={(event) => setNewMessage(event.target.value)}
            />
          </div>
          <button
            className="btn btn--outline btn--gold"
            type="button"
            disabled={!newMessage}
            onClick={() => postMessage()}
          >
            <span className="btn__content">
              <span className="btn__text">Post New Message</span>
            </span>
          </button>
        </div>

        {messages.length === 0 && (
          <div className="grid__col-xs-12">
            <hr />
            <p>There are currently no messages for this Project.</p>
          </div>
        )}

        {messages.length > 0 && (
          <>
            <div className="grid__col-xs-12 u--text-align-center">
              <div className="message">
                <hr />
                {unreadSince !== 0 && (
                  <button
                    type="button"
                    className="u--align-self--top u--justify-self-flex-end btn btn--md btn--blue btn--link module-hover-root"
                    onClick={() => {
                      handleMarkAsRead();
                      setUnreadSince(0);
                    }}
                  >
                    <span
                      className="btn__content"
                      style={{ lineHeight: '20px' }}
                    >
                      <span className="btn__text">Mark as read</span>
                    </span>
                  </button>
                )}
              </div>
            </div>
            {messages.map(
              (
                {
                  comment_is_new,
                  comment_by_builder,
                  comment_date,
                  comment_author,
                  comment_content
                },
                index
              ) => (
                <div key={index} className="grid__col-xs-12">
                  <div
                    className={`message${
                      comment_is_new == 1 ? ' message--is-new' : ''
                    }${comment_by_builder == 1 ? ' message--mine' : ''}`}
                  >
                    <div className="message__meta">
                      <h5 className="message__date">
                        {comment_is_new == 1 ? (
                          <span className="message__date--new">NEW — </span>
                        ) : (
                          ''
                        )}
                        {comment_date}
                      </h5>
                      <h5 className="message__author">
                        {comment_by_builder == 1
                          ? comment_author
                          : 'PERC Admin'}
                      </h5>
                    </div>
                    <p
                      className="message__content"
                      dangerouslySetInnerHTML={{ __html: comment_content }}
                    />
                  </div>
                </div>
              )
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Messages;
